import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-techblog',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './techblog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './techblog.component.scss'
})
export class TechblogComponent {

}
